@if (!isLoading() && error()) {
  <ideal-error [error]="error()" mode="button"></ideal-error>
} @else {}
<div container withLoadingSkeleton [isLoading]="!ready()" (widthChange)="onWidthChange($event)">
  @if (!isPriceOnRequest()) {
    <ideal-cart-item-quantity-selector-view
      [quantity]="quantity() || undefined"
      [pricing]="pricing()"
      [isUpdating]="isLoading()"
      [sellMultipleHints]="sellMultipleHints()"
      [compact]="compact()"
      (quantityChange)="onQuantityChange($event ?? 0)"
    />
  } @else {
    <ideal-call-for-price-button />
  }
</div>
